import { EnergyEfficiencyGrade, Product } from '../..';

export const noop = () => {};
export const isBrowser = () => typeof window !== 'undefined';

export function isTouchDevice() {
  return (
    !!(
      typeof window !== 'undefined' &&
      ('ontouchstart' in window ||
        ((window as any).DocumentTouch &&
          typeof document !== 'undefined' &&
          document instanceof (window as any).DocumentTouch))
    ) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
  );
}

export function sortByList<T>(list: T[], attribute: keyof T, sortList: string[]): T[] {
  return Object.values(
    sortList.reduce(
      (acc, next) => ({
        ...acc,
        [next]: list.find((item) => String(item[attribute]) === next),
      }),
      {},
    ),
  );
}

export const emailRegex = RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
);

export function isValidEmail(email: string): boolean {
  return emailRegex.test(email);
}

export function getEnergyEfficiencyGrade(product: Product): EnergyEfficiencyGrade | null {
  const efficency = (product.features?.energyEfficiency || [])[0];
  if (!efficency) {
    return null;
  }
  // France has this Label_énergétique_A etc
  // also strip all A+ to just A
  const efficiencyLetter = efficency.split('_').reverse()[0].replace(/\+/g, '').toUpperCase();

  if (['A', 'B', 'C', 'D', 'E', 'F', 'G'].includes(efficiencyLetter)) {
    return efficiencyLetter as EnergyEfficiencyGrade;
  }
  return null;
}
